module.exports = __webpack_public_path__ + "static/media/55_000018.ba183403.jpg";